export const ACTIONS_MAP = {
  VERIFY_IAM_SCREEN: {
    label: {
      ar: "توثيق",
      en: "Verify",
    },
    route: "/user-actions/verify-iam",
  },
  VERIFY_OFFICE_SCREEN: {
    label: {
      ar: "توثيق المكتب",
      en: "Verify office",
    },
    route: "/user/verify-office",
  },
  FEES_SCREEN: {
    label: {
      ar: "سداد الرسوم",
      en: "Pay fees",
    },
    route: "/services",
  },
  EXIT_ADD_LISTING: {
    label: {
      ar: "خروج",
      en: "Discard adding listing",
    },
    props: {
      theme: "default",
    },
  },
  NEXT: {
    label: {
      ar: "التالي",
      en: "Next",
    },
  },

  CUSTOMER_SUPPORT: {
    label: {
      ar: "توثيق",
      en: "Verify",
    },
    route: "/support",
  },
  SUBSCRIBE_TO_PKG: {
    label: {
      ar: "توثيق",
      en: "Verify",
    },
    route: "/payment-gateway/pricing-packages",
  },
  CUSTOMER_SUPPORT_WA: {
    label: {
      ar: "توثيق",
      en: "Verify",
    },
    route: "/support",
  },
  REGA_WEBSITE: {
    label: {
      ar: "توثيق",
      en: "Verify",
    },
    route: "https://aqr.to/rega-eservices",
    target: "_blank",
  },
  ADD_LISTING: {
    label: {
      ar: "إضافة إعلان",
      en: "Add Listing",
    },
    route: "/add-listing-v2/category",
  },
};
